import React, { useEffect, useState } from "react";
import { Card, Col, Nav, OverlayTrigger, Popover, Row, Tooltip } from "react-bootstrap";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { truncateText } from "../utils/utilities";
import ProblemListModal from "../components/modals/ProblemListModal";
import useManageProblemList from "../hooks/patientDashboard/useManageProblemList";
import Spinner1 from "../components/common/spinners";

export default function ProblemList() {
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  const [show, setShow] = React.useState(false);
  const [viewMore, setViewMore] = useState();

  const {loading, handleFetchProbList, probList} = useManageProblemList();

  useEffect(() => {
    handleFetchProbList()
  },[])

    const switchSkin = (skin) => {
        if (skin === 'dark') {
        const btnWhite = document.getElementsByClassName('btn-white');

        for (const btn of btnWhite) {
            btn.classList.add('btn-outline-primary');
            btn.classList.remove('btn-white');
        }
        } else {
        const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

        for (const btn of btnOutlinePrimary) {
            btn.classList.remove('btn-outline-primary');
            btn.classList.add('btn-white');
        }
        }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);


  const OpenModal = (id) => {
    setShow(true);
    setViewMore(id)
}


  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-md-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 className="main-title my-4 fw-bold">My Diagnosis, My Health Journey</h4>
          </div>
        </div>

        <div className={"divider divider-start fw-medium mx-3" }>
            <span>Problem List</span>
        </div> 

        <div className="d-md-flex align-items-center justify-content-between mb-4">
            <div>
                <h4 className="main-title mb-0"></h4>
            </div>
            <div className="d-flex gap-2 mt-3 mt-md-0">
            
            <Nav className="nav-icon nav-icon-sm ms-auto">
                <Nav.Link href=""><i className="ri-refresh-line text-success"></i></Nav.Link>
                <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
            </Nav>
            </div>
    
        </div> 

        <Row className="g-3 ">
            <Col xl="12">
                <Card className="card-one">   


                    <Card.Body className="p-3">
                        <div className="table-responsive mt-3 w-100">
                        
                            {
                            loading ? <div className=' w-100 d-flex justify-content-center '><Spinner1/></div> :
        
                            <table className="table table-agent mb-0 w-100" style={{ '--bs-table-bg': 'transparent', '--bs-table-color': 'transparent' }}>
                                <thead>
                                <tr>
                                    <th><h6 className="">Diagnosis</h6></th>
                                    <th><h6 className="">Type</h6></th>
                                    <th><h6 className="">Consultant</h6></th>
                                    <th><h6 className="">Comment</h6></th>
                                    <th><h6 className="">Status</h6></th>
                                </tr>
                                </thead>
                                    
                                {
                                    probList?.map((item)=>(
                                        <tbody key={item} className="cursor-pointer">
                                            <tr>
                                            <td>

                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
                                                        <i class="ri-capsule-fill"></i>
                                                    </div>
                                                    <div>
                                                        <h6 className="mb-0 fs-sm">
                                                            {truncateText(`${item?.diagnosis?.description ?? "---"}`, 35)}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <h6 className="mb-0 fs-sm">
                                                        {item?.diagnosis_type == "Differential" ? <span className="text-white badge bg-primary">{item?.diagnosis_type}</span> : item?.diagnosis_type == "Confirmed"? <span className="bg-success badge text-white">{item?.diagnosis_type}</span> :  item?.diagnosis_type == "Suspected" ? <span className=" text-white badge bg-danger">{item?.diagnosis_type}</span> : "---"}
                                                    </h6>
                                                </div>
                                            </td>
                                            <td>
                                                <h6 className="mb-0 fs-sm  text-capitalize">{item?.createdBy?? "---"}</h6>
                                            </td>
                                        
                                            
                                            <td>
                                                <div>
                                                    <h6 className="mb-0 fs-sm">
                                                        {truncateText(`${item?.comment?? "---"}`, 35) } 
                                                    </h6>
                                                </div>
                                            </td>
                                            <td>
                                                <h6 className="bg-success text-white px-2 py-1 badge mb-0 fs-sm">
                                                    Active
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="d-flex gap-2">
                                                    <OverlayTrigger
                                                        placement="top" 
                                                        overlay={<Tooltip id="tooltip-top">view more!</Tooltip>}>
                                                            <span onClick={() => OpenModal(item)} className="nav-link text-secondary">
                                                            <i class="ri-eye-line"></i>
                                                            </span>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>
                                                                            
                                            </tr>
                                        </tbody>
                                    ))
                                }
                                
                            </table>
        
                            }
                        </div>
                    </Card.Body>
                </Card>
            </Col>
          
        </Row>
        <ProblemListModal setShow={setShow} show={show} data={viewMore} />
        <Footer />
      </div>
    </React.Fragment>
  );
}
